import { Alert } from "@gravity-ui/uikit";
import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";
import { PRICE_CONFIRM_KEY } from "src/pages/ProductDetailPage/ProductDetailPage.constant";
import { ShowConfirmDialog } from "src/widgets/Alert/Alert";

import { PriceProps } from "../../PriceProps";
import { ProductModalBodyContent } from "./ProductModalBodyContent";
import { checkLocalStorage } from "./utils";

export interface ProductModalBodyProps {
  product: ProductDetailResponseDto;
  platform: null | ProductSourceDtoSourceEnum;
  setPlatform: (platform: null | ProductSourceDtoSourceEnum) => void;
  hasSubscribe?: boolean;
  reload: () => void;
  isDesktop: boolean;
  priceProps: PriceProps;
}

export const ProductModalBody = ({
  product,
  platform,
  setPlatform,
  hasSubscribe,
  reload,
  isDesktop,
  priceProps,
}: ProductModalBodyProps) => {
  const onPlatformChange = async (
    platform: ProductSourceDtoSourceEnum | null,
  ) => {
    if (!platform) {
      setPlatform(null);
      return;
    }
    const confirmed = await confirmPriceRequestOnce();
    if (!confirmed) return;
    setPlatform(platform);
  };

  return (
    <ProductModalBodyContent
      product={product}
      source={product.productSources}
      platform={platform}
      reload={reload}
      setPlatform={onPlatformChange}
      hasSubscribe={hasSubscribe}
      isDesktop={isDesktop}
      priceProps={priceProps}
    />
  );
};

const confirmPriceRequestOnce = async (): Promise<boolean> => {
  if (checkLocalStorage()) {
    return true;
  }

  const result = await ShowConfirmDialog(
    <Alert
      theme="info"
      title="Загрузка цен"
      message="При загрузке новых цен будет списан запрос."
    />,
    "Подтвердите действие",
  );

  if (result) {
    localStorage.setItem(PRICE_CONFIRM_KEY, "true");
  }

  return result;
};
